import {ViewName} from "@kta20-core/interfaces/view-name";
import {ViewNames} from "@kta20-task-manager/constants";

export const ModuleViews: ViewName[] = [
    {
        name: ViewNames.TASK_REPORTING_VIEW,
        loader: async () => { await import(`@kta20-task-manager/views/task-reporting-view/task-reporting-view`); },
        loaded: false
    },
    {
        name: ViewNames.TASK_FORM_VIEW,
        loader: async () => { await import(`@kta20-task-manager/views/task-form-view/task-form-view`); },
        loaded: false
    },
    {
        name: ViewNames.TASK_CLOSURE_FORM_VIEW,
        loader: async () => { await import(`@kta20-task-manager/views/task-closure-form-view/task-closure-form-view`); },
        loaded: false
    }
];